// Copyright TraderEvolution Global LTD. © 2017-2024. All rights reserved.

export const CouponCycle = {
    OneMonth: 0,
    ThreeMonth: 1,
    SixMonth: 2,
    Year: 3
}